import React from 'react';
import Slider from 'react-slick';
import projectData from 'core/data/projects.json';
import { downloadFileSettings } from 'core/config/slides';

const UpcomingProductV1 = () => {
	let publicUrl = process.env.PUBLIC_URL + '';

	return (
		<div className="section-bg-1--- bg-image-top" style={{ marginBottom: '150px' }}>
			<div className="section-bg-1--- bg-image-top p-5"
				style={{ backgroundImage: `url(${publicUrl + projectData.backgroundImage})`, maxHeight: '410px' }} >
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<div className="section-title-area ltn__section-title-2--- text-center---">
								<h6 className="section-subtitle section-subtitle-2--- ltn__secondary-color--- white-color m-0">{projectData.sectionSubtitle}</h6>
								<h1 className="section-title white-color mt-3">{projectData.sectionTitle}</h1>
							</div>
						</div>
					</div>
					<Slider {...downloadFileSettings} className="ltn__upcoming-project-slider-1-active slick-arrow-3" style={{ marginBottom: '-170px' }}>
						{projectData.sliderImages.map((image, index) => (
							<div className="col-lg-4" key={index}>
								<img src={publicUrl + image} alt={`Slider ${index + 1}`} />
							</div>
						))}
					</Slider>
				</div>
			</div>
		</div>
	);
}

export default UpcomingProductV1;